import { parseOmnisearchTokens } from "utils/omnisearchUtils";

/**
 * Base file name for a manifests export, named for a shipped year only when
 * the exported search is bounded to that one year. A correction-date drilldown
 * drops the year picker's scope, so its rows can come from any shipped year.
 */
export function manifestsExportFileName(search: string): string {
  const year = boundShippedYear(search);
  return year ? `waste-manifests-${year}` : "waste-manifests";
}

/** The shipped year a search is bounded to, if exactly one term bounds it. */
function boundShippedYear(search: string): string | undefined {
  const years = parseOmnisearchTokens(search).flatMap((token) => {
    const year = /^shippedDate:(\d{4})$/.exec(token)?.[1];
    return year ? [year] : [];
  });
  return years.length === 1 ? years[0] : undefined;
}
